import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface SuccessNotificationProps {
  isVisible: boolean;
  onClose: () => void;
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({ isVisible, onClose }) => {
  const { t } = useTranslation(['therapyAppointment']);

  const [showPopUp, setShowPopUp] = React.useState(false);

  useEffect(() => {
    setShowPopUp(isVisible);
  }, [isVisible]);

  return (
    <>
      {showPopUp && (
        <div className='fixed inset-0 bg-opacity-50 flex items-center justify-center z-50'>
          <div
            className='bg-indigo-100 rounded-2xl p-6 shadow-lg flex flex-col items-center justify-center w-[80%] h-[60%]'
            style={{
              position: 'absolute',
              bottom: '80px',
              right: '100px',
              height: '62vh',
              width: '72%',
              alignContent: 'center',
            }}
          >
            <div className='bg-blue-600 rounded-full p-3 mb-4'>
              <svg
                className='w-8 h-8 text-white'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='3'
                  d='M5 13l4 4L19 7'
                />
              </svg>
            </div>

            <p className='text-center text-xl text-gray-800 mb-8'>
              {t('summaryAddedSuccessfully', { defaultValue: 'Summary Added Successfully' })}
            </p>

            <button
              className='bg-blue-600 hover:bg-blue-700 text-white py-2 px-12 rounded-md'
              onClick={onClose}
            >
              {t('ok', { defaultValue: 'OK' })}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessNotification;
